import { createApp } from 'vue';
import App from './App.vue';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css'; // 引入样式
import './element-variables.scss';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import router from './router';
import './style.css';
import './styles/global.scss';
import zhCn from 'element-plus/es/locale/lang/zh-cn'

const app = createApp(App);

// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

app.use(ElementPlus, {
  locale: zhCn,
});
app.use(router);
app.mount('#app');
